import React, { Component } from 'react';
import { t } from '../../../helpers/translate.helper';
import { cx } from '../../../helpers/ClassNames.helper';

import styles from './CookieConsent.module.scss';

export default class CookieConsent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      status: localStorage.getItem('cookie-status'),
    }
  }

  setStatus(newStatus) {
    localStorage.setItem('cookie-status', newStatus);
    this.setState({ status: newStatus });
  }

  render() {
    const { children } = this.props;
    const { status } = this.state;

    if (status == null) {
      return (
        <div className={styles.host}>
          <p className={styles.text}>
            {t`cookie.message`+' '}
            <a href={t`cookie.policyLink`}>{t`cookie.policy`}</a>
          </p>
          <div className={styles.buttons}>
            <div
              className={cx(styles.button, styles.deny)}
              onClick={() => this.setStatus('denied')}
            >
              {t`cookie.deny`}
            </div>
            <div
              className={cx(styles.button, styles.allow)}
              onClick={() => this.setStatus('allowed')}
            >
              {t`cookie.allow`}
            </div>
          </div>
        </div>
      );
    }
    else if (status === 'allowed') {
      return (
        <>
          {children}
        </>
      )
    }
    else {
      return null;
    }
  }
}

